











import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class TaxReturnProgress extends Vue {

    @Prop()
    progressPercentage!: number;

    private mounted() {
        window.addEventListener('resize', this.onResizeEvent);
        this.onResizeEvent();
    }

    private beforeDestroy() {
        window.removeEventListener('resize', this.onResizeEvent);
    }

    private onResizeEvent() {
        const progressTextOuter = document.getElementById('progress-text-outer');
        const progressOuter = document.getElementById('progress-outer');
        const progressTextInner = document.getElementById('progress-text-inner');
        if (progressTextOuter && progressOuter && progressTextInner) {
            const progressTextOuterStyle = window.getComputedStyle(progressTextOuter);
            const progressWidth = progressOuter.offsetWidth - parseInt(progressTextOuterStyle.marginRight);
            progressTextInner.setAttribute('style', `width: ${progressWidth}px`);
        }
    }
}

